export default function (entity) {

    entity.remove('timeout');
};
